export default function AddressOptionSkeleton() {
  return (
    <div
      className='flex h-[5.313rem] items-center justify-between rounded-[10px] border border-[#E5E7EB] px-[19px] transition-all duration-150'
      aria-hidden='true'
    >
      {/* left: icon + text */}
      <div className='flex h-full items-center gap-[16px]'>
        {/* circular icon placeholder */}
        <div className='flex h-12 w-12 animate-pulse items-center justify-center rounded-full bg-gray-200' />

        {/* text placeholders */}
        <div className='w-[60%]'>
          <div className='mb-[7px] h-[18px] w-44 animate-pulse rounded bg-gray-200' />
          <div className='mt-1 h-[14px] w-2/3 animate-pulse rounded bg-gray-200' />
        </div>
      </div>

      {/* right: icons placeholders */}
      <div className='flex items-center gap-[22px]'>
        <div className='h-6 w-6 animate-pulse rounded bg-gray-200' />
        <div className='h-6 w-6 animate-pulse rounded bg-gray-200' />
      </div>
    </div>
  );
}
